import { render, staticRenderFns } from "./sunArticle.vue?vue&type=template&id=32bddc9e&scoped=true&"
import script from "./sunArticle.vue?vue&type=script&lang=js&"
export * from "./sunArticle.vue?vue&type=script&lang=js&"
import style0 from "./sunArticle.vue?vue&type=style&index=0&id=32bddc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bddc9e",
  null
  
)

export default component.exports